import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="tech-grid scroll-mt-4 bg-blue-950 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gz2sqezjay">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1n9irsce692e3">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-166" data-mp="1ncwuxmuntfml">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-slate-300/60 bg-blue-900 shadow-2xl shadow-black/40" data-id="element-167" data-mp="1x9rp5tjwgtv2">
          <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-168" data-mp="2271llt5pi5se" />
          <div className="p-6 sm:p-10" data-id="element-169" data-mp="2vqqb8oco6uz">
            <span className="silver-metal inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-blue-950" data-id="element-170" data-mp="2ws61qgb9hj1">
              <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="1mhg9skngd5a3" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-slate-300/20 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-172" data-mp="1hodfuberjttd">
              <div data-id="element-173" data-mp="1coiqwdejteay">
                <h3 className="text-2xl font-extrabold leading-tight text-white" data-id="element-174" data-mp="17sae36ntpx6y">{productShortName}</h3>
                <p className="mt-2 text-sm text-slate-300" data-id="element-175" data-mp="25g2avziyywe0">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-176" data-mp="1vgl9vvenx6od">
                <span className="text-sm text-slate-300" data-id="element-177" data-mp="1vj7fhphztc3y">
                  Precio regular: <span className="line-through" data-id="element-178" data-mp="1rf7zd80mkfb4">{priceBefore}</span>
                </span>
                <p className="mt-1 flex items-baseline gap-2 sm:justify-end" data-id="element-179" data-mp="k2zc5luqlwr8">
                  <span className="text-sm font-bold uppercase text-slate-300" data-id="element-180" data-mp="g0clvpdpsjw5">Hoy:</span>
                  <span className="text-5xl font-extrabold tracking-tight text-white" data-id="element-181" data-mp="hh887911hv5f">{price}</span>
                </p>
                <p className="silver-metal mt-2 inline-block rounded-md px-2.5 py-1 text-xs font-extrabold uppercase tracking-[.14em] text-blue-950" data-id="element-182" data-mp="mft8t9k7egue">
                  50% de descuento
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-183" data-mp="ckhv8ukj7fo8">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-slate-100" data-id="element-184" data-mp="3uuthsl7r4ys9">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-185" data-mp="3kyi5hv85w8xt" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-186" data-mp="3pvgxa74cs3su">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-200" data-id="element-187" data-mp="3fy3uq5f6ekw3">
              <span className="inline-flex items-center gap-1.5" data-id="element-188" data-mp="2xbd60twdl6rb">
                <LockIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-189" data-mp="2scs0qg29nww0" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-190" data-mp="36ckpi5u8g31c">
                <ZapIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-191" data-mp="31c6ubodqcnkq" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-192" data-mp="3g8xit2lv8evk">
                <ShieldCheckIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-193" data-mp="3baw4euzdx3qf" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-slate-300" data-id="element-194" data-mp="3p0zhowgadn3q">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}